<template>
    <div class="body">
        <!-- Layout -->
        <div class="show-chat-web" v-if="screenWidth > 950">
            <WebChat
                :isConversation = "isConversation"
                :currentConversationId = "currentConversationId"
                :receiverId = "receiverId"
                :isDashboardCompany = "isDashboardCompany"
                :conversations = "conversations"
                :currentUser = "currentUser"
                :currentUserId = "currentUserId"
                :currentConversationName = "currentConversationName"
                :messages = "messages"
                :message = "message"
                :isMessage = "isMessage"
                :closeChat = "closeChat"
                :baseUrl = "baseUrl"
                :selectConversation = "selectConversation"
                :saveConversation = "saveConversation"
                @updateMessage="handleMessageUpdate"
                ref="resetMessageChat"
                :formatDateCustomized="formatDateCustomized"
            />
        </div>
        <div class="show-chat-mobile" v-else>
            <MobileChat
                :isConversation = "isConversation"
                :currentConversationId = "currentConversationId"
                :receiverId = "receiverId"
                :isDashboardCompany = "isDashboardCompany"
                :conversations = "conversations"
                :currentUser = "currentUser"
                :currentUserId = "currentUserId"
                :currentConversationName = "currentConversationName"
                :messages = "messages"
                :message = "message"
                :isMessage = "isMessage"
                :closeChat = "closeChat"
                :baseUrl = "baseUrl"
                :selectConversation = "selectConversation"
                :saveConversation = "saveConversation"
                @updateMessage="handleMessageUpdate"
                ref="resetMessageChat"
                :formatDateCustomized="formatDateCustomized"
            />
        </div>
        <!-- Layout -->
    </div>
</template>
  
<script>
  import Chat from '@/store/services/chat/chat.service.js'
  import moment from 'moment'
  import WebChat from "./WebChat.vue"
  import MobileChat from "./MobileChat.vue"
  export default {
    props: {
        closeChatModal: Function
    },
    components: {
        WebChat,
        MobileChat
    },
  
    data() {
      return {
        connectedUserId: 9,
        CMScontact: `${process.env.VUE_APP_CMS_URL}contact`,
        loader: false,
        companies: [],
        sortByAsc: false,
        currentUserId: localStorage.getItem('user_id'),
        receiverId: null,
        message: null,
        conversations: [],
        messages: [],
        isMessage: true,
        currentConversationId: null,
        currentConversationName: null,
        currentUser: null,
        baseUrl: window.location.protocol + '//' + window.location.host + '/storage/',
        // screenWidth: window.innerWidth,
        isConversation: true,

        screenWidth: window.innerWidth,
        screenHeight: window.innerHeight,
      };
    },
  
    methods: {
      closeChat () {
        this.closeChatModal();
      },
      getConversations () {
        Chat.getConversations().then((res) => { 
          if (res) {
            this.conversations = res.data;
          }
        }).catch((error) => {
          console.error("Error fetching conversations:", error);
        });
      },
  
      getAllMessages (conversationId) {
        Chat.getMessages(conversationId).then((res) => {
          if (res) {
            this.messages = res.data;
            this.markConversationAsViewed(conversationId)
          }
        })
      },

      markConversationAsViewed (conversationId) {
        Chat.markMessagesAsRead(conversationId)
        this.$store.commit("IS_MESSAGE_UPDATE", conversationId);
        this.getConversations();
      },
  
      saveConversation (e) {
        e.preventDefault();
        const data = {
          to: this.receiverId,
          conversation: this.message,
          activated: 1
        }
  
        if (this.message) {
          this.isMessage = true;
        } else {
          this.isMessage = false;
          return;
        }
  
        Chat.saveConversation(data).then((res) => {
          this.getAllMessages(res.data.conversation.id)
          this.message = null;
          this.resetMessage();
          this.getConversations()
        }).catch((e) => {
          console.log(e);
        });
      },
  
      timeAgo(date) {
        return moment(date).fromNow();
      },

      formatDateCustomized(dateStr) {
        const options = { year: 'numeric', month: 'short', day: '2-digit', hour: 'numeric', minute: '2-digit', hour12: true };
        return new Date(dateStr)
            .toLocaleString('en-US', options)
            .replace(',', '')
            .replace(' AM', 'AM')
            .replace(' PM', 'PM');
      },

      handleResize() {
        this.screenWidth = window.innerWidth;
      },

      getScreenSize() {
        this.screenWidth = window.innerWidth;
        this.screenHeight = window.innerHeight;
      },

      selectConversation(conversation) {
        this.currentConversationId = conversation.id;
        this.receiverId = this.isDashboardCompany ? conversation.sender.id : conversation.company.user_id;
        this.currentConversationName = this.isDashboardCompany ? `${conversation.sender.first_name} ${conversation.sender.last_name}`  : conversation.company.company_name;
        this.currentUser = conversation;
        this.getAllMessages(conversation.id);
        this.isConversation = false
      },
      handleMessageUpdate(newMessage) {
        this.message = newMessage;
      },
      resetMessage() {
        this.$refs.resetMessageChat.resetMessage();
      }
    },
  
    mounted() {
      this.getConversations()
      this.currentUserId = localStorage.getItem('user_id')
      window.addEventListener('resize', this.getScreenSize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.getScreenSize);
    },
  
    created () {
      this.baseUrl = window.location.protocol + '//' + window.location.host + '/storage/';
    },
  
    computed: {
      isDashboardCompany () {
        return this.$route.path === "/dashboard/company";
      },
    }
  };
</script>
<style lang="css" scoped src="../../assets/styles/chat.css"></style>
